import { Box, BoxProps } from '@mantine/core';
import { ReactNode } from 'react';

interface TableCellInLineContentProps extends BoxProps {
  children: ReactNode;
}

export const TableCellInLineContent = ({ children, ...props }: TableCellInLineContentProps) => {
  return (
    <Box
      style={{
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
